import { Grid } from '@mui/material';
import { default as cx } from 'classnames';
import { FLOW_CATEGORY } from 'new/components/flows/types/flowTypes';
import { Box } from 'new/elements/Box';
import { flowDataMap, flowDataMapItems } from 'new/elements/flows/dataMap';
import { FlowType } from 'new/elements/flows/types';
import React, { FC, FunctionComponent, SVGAttributes } from 'react';
import classes from './FlowTypeCard.module.scss';
import { chipDataTitleMap, FlowTypeCardText } from './FlowTypeCardText';

type FlowTypeCardProps = {
  type: FlowType;
  selected?: boolean;
  onFlowSelected?(type: FlowType): void;
  handleOnClickNew?(a: string): void;
  isEnabled?: boolean;
};

export const FlowTypeCard: FC<FlowTypeCardProps> = ({
  type,
  onFlowSelected,
  isEnabled,
  handleOnClickNew,
  selected,
}) => {
  const { title, subTitle, chip, IconComponent } = flowDataMap[type];
  const inDevelopment = flowDataMapItems[FLOW_CATEGORY.coming_soon].includes(type);
  const handleInteraction = () => onFlowSelected && onFlowSelected(type);
  const handleOnClick = () => {
    if (handleOnClickNew) {
      handleOnClickNew(type);
    }
    return null;
  };
  const ctaLabel = isEnabled ? 'Create' : 'Request Access';
  return (
    <Box
      onMouseEnter={handleInteraction}
      onClick={!inDevelopment ? handleOnClick : null}
      className={cx({
        [classes.container]: true,
        [classes.container_active]: selected,
        [classes.container_disabled]: inDevelopment,
      })}
    >
      <Grid container data-testid={`flow-type-${type}`} spacing={1}>
        <Grid item xs={12}>
          <FlowTypeCardText
            title={title}
            isSelected={selected}
            titleVariant="subtitle2"
            chipProps={chipDataTitleMap[chip]}
            position="end"
            StartIcon={IconComponent as FunctionComponent<SVGAttributes<SVGElement>>}
          />
        </Grid>
        <Grid item xs={12}>
          <FlowTypeCardText position="start" title={subTitle} titleVariant="body3" />
        </Grid>
      </Grid>
    </Box>
  );
};
